















import { Component, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { AuthStateInterface } from '../../../auth/interfaces/authState';

@Component({
    name: 'profile-dropdown',
})
export default class ProfileDropdown extends Vue {
  @State('auth') private auth!: AuthStateInterface;

  get user() {
    return this.auth.user;
  }

  public logout() {
    this.$router.push('/logout');
  }

  public goToProfile() {
    this.$router.push('/profile');
  }
}
